module.exports = __webpack_public_path__ + "static/service-cs-cb-half-eaefff0cb2484ea4abe0d282923eb210.jpg";